import { apiClient } from '@/lib/apiClient';

/**
 * Speech to text for the assistant's microphone.
 *
 * Transcription only: no clinical extraction and no wallet charge. Charting a visit goes through
 * `transcribeDictation` on the consultation, which is what the €0.10 session price pays for.
 */
export const transcribeSpeech = async (audio: Blob): Promise<{ text: string }> => {
  const form = new FormData();
  form.append('audio', audio, 'speech.webm');
  const { data } = await apiClient.post<{ text: string }>('/ai/transcribe', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};
